export default __webpack_public_path__ + "4edf3fa463c72c465ca2d59941ba1088.png";